import objectAssign from "object-assign";
import actionTypes from "actionTypes";

const initialState = {
  fileUploadTimeStamp: null
}

export default function offlinePayments(state, action) {
	if (typeof state === "undefined") {
		return initialState;
	}

	let newState = null;

	switch (action.type) {
		case actionTypes.SET_FILE_UPLOAD_TIMESTAMP:
			newState = objectAssign({}, state);
			newState.fileUploadTimeStamp = action.payload;
			return newState;
	}
	return state;
}